/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */

export type ProjectFileCategoryID = (typeof ProjectFileCategoryID)[keyof typeof ProjectFileCategoryID];

export const ProjectFileCategoryID = {
  CONTRACT: 'contract',
  PROTOCOL: 'protocol',
  IRB_APPLICATION: 'irb-application',
  IRB_APPROVAL: 'irb-approval',
  DATA_SECURITY_PLAN: 'data-security-plan',
  PUBLICATION: 'publication',
  OTHER: 'other',
} as const;
